import { useState } from "react";
import Language from "../../lib/Language";
import ScratchpadList from "../ScratchpadList";
import { useAppContext } from "../../contexts/AppContext";
import { Typography } from "@timeedit/ui-components/components/Typography/Typography";
import Tooltip from "@timeedit/ui-components/components/Tooltip/Tooltip";
import Icon from "@timeedit/ui-components/components/Icon/Icon";
import { TOOLTIP_DELAY } from "../../lib/UIConstants";

type TPinboardContentProps = {
    height: string;
    showTitle: boolean;
};

const PinboardContent = (props: TPinboardContentProps) => {
    const { scratchpad, user } = useAppContext();
    const [, setRefresh] = useState(0);

    let isRemoveClick = false;

    const onObjectSelected = (object: { id: number }) => {
        if (isRemoveClick) {
            scratchpad.removeObjects([object.id]);
            setRefresh((n) => n + 1);
        }
        isRemoveClick = false;
    };

    const unpinButton = (
        <button
            className="deprecated unpinButton"
            onClick={() => {
                isRemoveClick = true;
            }}
            title={Language.get("nc_remove_from_pinboard")}
        />
    );

    return (
        <div
            className="pinboardContent"
            style={{
                display: "flex",
                flexDirection: "column",
                minWidth: 300,
                height: props.height,
            }}
        >
            {props.showTitle ? (
                <div style={{ padding: "8px 12px" }}>
                    <h3 style={{ margin: 0 }}>
                        {Language.get("nc_pinboard")}{" "}
                        <Tooltip
                            mouseEnterDelay={TOOLTIP_DELAY}
                            title={
                                <Typography.Text
                                    style={{ margin: "4px 0 0", fontSize: 12, color: "white" }}
                                >
                                    {Language.get("nc_pinboard_info")}
                                    <br />
                                    <Typography.Link
                                        openInNewTab={true}
                                        style={{ color: "white" }}
                                        href="https://academy.timeedit.com/guides-tutorials/pinboard"
                                    >
                                        {Language.get("nc_pinboard_on_te_academy")}
                                    </Typography.Link>
                                </Typography.Text>
                            }
                        >
                            <span>
                                <Icon id="QuestionCircleOutlined" alt={Language.get("menu_help")} />
                            </span>
                        </Tooltip>
                    </h3>
                </div>
            ) : null}
            <ScratchpadList
                flex={true}
                showExtraInfo={user?.showExtraInfo ?? false}
                objects={scratchpad.getObjects()}
                onObjectSelected={onObjectSelected}
                allowMultiSelection={true}
                hoverButton={unpinButton}
            />
        </div>
    );
};

export default PinboardContent;
